import { render, staticRenderFns } from "./subjectNum.vue?vue&type=template&id=33ce504e&"
import script from "./subjectNum.vue?vue&type=script&lang=js&"
export * from "./subjectNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports